// extracted by mini-css-extract-plugin
module.exports = {"legal":"Legal_legal__hPKBN","regular":"Legal_regular__3c3qV","bold":"Legal_bold__2ic9F"};